import { ProductionMultiSelect } from "@components/multi-select/ProductionMultiSelect"
import { ActivityTypeTreeSelect } from "@components/tree-select/ActivityTypeTreeSelect"
import { CollectiveTreeSelect } from "@components/tree-select/CollectiveTreeSelect"
import { GenreTreeSelect } from "@components/tree-select/GenreTreeSelect"
import { LocationTreeSelect } from "@components/tree-select/LocationTreeSelect"
import { DateRangePickerInputWithSeasonPresets } from "@components/date-picker/DateRangePickerInputWithSeasonPresets"
import { UseFormReturnType } from "@mantine/form"
import { useTranslation } from "react-i18next"
import { CalendarProfileFormValues } from "./CalendarProfileForm"

export function ActivityCalendarFields({
  form,
}: {
  form: UseFormReturnType<CalendarProfileFormValues>
}) {
  const { t } = useTranslation("app_server")
  const settings = form.values.activitySettings

  return (
    <>
      <DateRangePickerInputWithSeasonPresets
        label={t("TimePeriod")}
        value={[settings.start ?? null, settings.end ?? null]}
        onChange={([start, end]) => {
          form.setFieldValue("activitySettings.start", start)
          form.setFieldValue("activitySettings.end", end)
        }}
      />
      <ProductionMultiSelect
        period={{
          start: settings.start ?? undefined,
          end: settings.end ?? undefined,
        }}
        value={settings.productionIds ?? []}
        onChange={(value) =>
          form.setFieldValue("activitySettings.productionIds", value)
        }
      />
      <LocationTreeSelect
        value={settings.locationNodeIds ?? []}
        onChange={(value) =>
          form.setFieldValue("activitySettings.locationNodeIds", value)
        }
      />
      <ActivityTypeTreeSelect
        value={settings.activityTypeNodeIds ?? []}
        onChange={(value) =>
          form.setFieldValue("activitySettings.activityTypeNodeIds", value)
        }
      />
      <GenreTreeSelect
        value={settings.genreNodeIds ?? []}
        onChange={(value) =>
          form.setFieldValue("activitySettings.genreNodeIds", value)
        }
      />
      <CollectiveTreeSelect
        value={settings.collectiveNodeIds ?? []}
        onChange={(value) =>
          form.setFieldValue("activitySettings.collectiveNodeIds", value)
        }
      />
    </>
  )
}
